import React from 'react'
import {Link} from 'gatsby'
import moment from 'moment'

const getPostCategories = tagGroups => {
	let catShow = {}
	let categories = {}

	if (!tagGroups || !Array.isArray(tagGroups)) {
		return catShow
	}

	tagGroups.map(tagsChild => {
		return ['public', 'quartiers', 'participation'].includes(tagsChild.slug) ?
			tagsChild.tags.map(child =>
				categories[tagsChild.slug] = categories[tagsChild.slug] ? `${categories[tagsChild.slug]} . ${child.label}` : child.label
			):
			tagsChild.slug !== 'reseau-metropole-de-lille' && tagsChild.slug !== 'organise-par-la-ville-de-roubaix' && tagsChild.tags.map(child =>
				categories.other = categories.other ? `${categories.other} . ${child.label}` : child.label
			)
	})

	categories.public && (catShow.target = categories.public)
	categories.participation && (catShow.target = catShow.target ? `${catShow.target} . ${categories.participation.replace('Événement gratuit', 'Gratuit')}` : categories.participation.replace('Événement gratuit', 'Gratuit'))
	categories.other && (catShow.other = categories.other.replace('. Newsletter','').replace('. A la une','').replace('. A ne pas rater','').replace('. Site Zéro Déchet',''))

	return catShow
}

const AgendaListItem = ({postIndex, postItem}) => {
	// Validation des props et gestion des erreurs
	if (!postItem || typeof postItem !== 'object') {
		return (
			<article role="article" aria-label="Événement invalide" className="agenda-list-item-error">
				<div role="alert" aria-live="polite">
					<p>Erreur : données de l'événement manquantes ou invalides</p>
				</div>
			</article>
		)
	}

	const {title, originalImage, canonicalUrl, locationName, tagGroups, firstDate, lastDate} = postItem
	
	// Validation des données essentielles
	if (!title || !canonicalUrl) {
		return (
			<article role="article" aria-label="Événement incomplet" className="agenda-list-item-incomplete">
				<div role="alert" aria-live="polite">
					<p>Événement incomplet : titre ou URL manquants</p>
				</div>
			</article>
		)
	}

	const postCatName = getPostCategories(tagGroups)
	
	// Nettoyage et validation du titre
	const cleanTitle = title.fr && title.fr.trim() ? title.fr.replace(/<[^>]*>/g, '') : null
	
	// Construction de l'URL
	// Ex : https://openagenda.com/<slug>/event(s)/..., https://openagenda.com/fr/<slug>/event(s)/...
	const normalizedUrl = canonicalUrl.replace(
		/^https?:\/\/openagenda\.com\/(?:[^/]+\/)+?events?\//,
		'/agenda/'
	)
	
	// Construction de l'aria-label pour l'article
	const articleLabel = `${cleanTitle || 'Sans titre'}${locationName ? ` - ${locationName}` : ''}${firstDate ? ` - ${moment(firstDate).format('DD MMM YYYY')}` : ''}`
	
	// Construction de l'aria-label pour le lien
	const linkLabel = `Voir les détails de l'événement : ${cleanTitle || 'Sans titre'}${locationName ? ` à ${locationName}` : ''}`
	
	// Gestion de l'ID de l'article
	const articleId = `agenda-item-${postIndex !== undefined && postIndex !== null ? postIndex : 'unknown'}`
	const titleId = `agenda-title-${postIndex !== undefined && postIndex !== null ? postIndex : 'unknown'}`

	return (
		<article 
			role="article" 
			aria-label={articleLabel}
			id={articleId}
			className="agenda-list-item-content"
		>
			<Link 
				className="agenda-list-item-link" 
				to={normalizedUrl} 
				aria-label={linkLabel}
				aria-describedby={articleId}
			>
				<div className="agenda-list-item-content agenda-list-item-">
					{originalImage && (
						<div 
							className="agenda-list-item-content-picture" 
							style={{backgroundImage: `url(${originalImage})`}}
							role="img"
							aria-label={`Image de l'événement : ${cleanTitle || 'Sans titre'}`}
						></div>
					)}
					
					{postCatName.other && (
						<p className="agenda-list-item-content-cateory" role="note" aria-label="Catégorie de l'événement">
							{postCatName.other}
						</p>
					)}
					
					<div className="agenda-list-item-content-info" role="group" aria-label="Informations de l'événement">
						{cleanTitle && (
							<h2 
								className="agenda-list-item-content-title"
								id={titleId}
							>
								{cleanTitle}
							</h2>
						)}
						
						<div className="agenda-list-item-content-infos" role="group" aria-label="Détails de l'événement">
							{locationName && (
								<p className="agenda-list-item-content-location" aria-label="Lieu de l'événement">
									{locationName}
								</p>
							)}
							{postCatName.target && (
								<p className="agenda-list-item-content-target" aria-label="Public cible de l'événement">
									{postCatName.target}
								</p>
							)}
						</div>
						
						{(firstDate || lastDate) && (
							<p className="agenda-list-item-content-date" role="group" aria-label="Dates de l'événement">
								{firstDate && (
									<time 
										className="agenda-list-item-content-date-begin" 
										dateTime={moment(firstDate).format('YYYY-MM-DD')}
										aria-label="Date de début"
									>
										{moment(firstDate).format('DD MMM')}
									</time>
								)}
								{lastDate && firstDate && firstDate !== lastDate && (
									<>
										<span aria-hidden="true"> - </span>
										<time 
											className="agenda-list-item-content-date-end" 
											dateTime={moment(lastDate).format('YYYY-MM-DD')}
											aria-label="Date de fin"
										>
											{moment(lastDate).format('DD MMM')}
										</time>
									</>
								)}
							</p>
						)}
					</div>
				</div>
			</Link>
		</article>
	)
}

export default AgendaListItem
